import {
  aMatchListItem,
  anItemMeta,
  anUpdateMatchListItem,
  mockUpdateMatchListItemOperationMutation,
  UpdateMatchListItemOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

import { MATCH_LIST_ITEM_DATA } from '../queries/MatchListItemsOperation.mocks';

export const mockUpdateMatchListItemMutation: UpdateMatchListItemOperationMutation =
  {
    __typename: 'Mutation',
    updateMatchListItem: anUpdateMatchListItem({
      data: aMatchListItem({
        id: '1',
        value: MATCH_LIST_ITEM_DATA.value,
        expiration: MATCH_LIST_ITEM_DATA.expiration,
        meta: anItemMeta({
          description: MATCH_LIST_ITEM_DATA.updatedDescription,
        }),
      }),
      finishedProcessing: true,
    }),
  };

export const handlers = [
  mockUpdateMatchListItemOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: mockUpdateMatchListItemMutation,
      });
    }
  ),
];
